<template>
  <el-dialog
      :visible="isVisible"
      @close="hide"
      :title="title"
      :destroy-on-close="true"
  >
    <loading v-if="!isInitialized"></loading>
    <approved-message-form v-if="isInitialized" v-bind="formData" @stored="onStored"></approved-message-form>
  </el-dialog>
</template>

<script>
import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
import ApprovedMessageForm from '../../components/approved-message/form';
import Loading from '../../components/loading';
import eventBus from '../../event-bus';

export default {
  extends: BaseDialogFormWrapper,

  components: {
    Loading,
    ApprovedMessageForm,
  },

  computed: {
    /**
     * @return {boolean}
     */
    modelExists() {
      return _.has(this.formData, 'model.id');
    },

    /**
     * @return {string}
     */
    title() {
      if (!this.isInitialized) {
        return 'Loading ...';
      } else if (this.modelExists) {
        return 'Edit Approved Message';
      }

      return 'Create Approved Message';
    },
  },

  methods: {
    /**
     * @param {string|undefined} message
     */
    onStored({message}) {
      _.isString(message) && this.$message.success(message);
      this.hide();
      eventBus.$emit('refresh-approved-message-table');
    },
  },

  created() {
    eventBus.$on('show-approved-message-form-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-approved-message-form-dialog', this.show);
  }
}
</script>
